/**
 * AUTO-GENERATED — Do not edit blogPosts.generated.json manually.
 * Run: npm run build:blog
 * Source: content/blog/*.md
 */

import blogPostsData from './blogPosts.generated.json';

export interface BlogPost {
  slug: string;
  title: string;
  author: string;
  date: string;
  excerpt: string;
  image: string;
  imageAlt?: string | null;
  content: string;
}

export const blogPosts: BlogPost[] = blogPostsData as BlogPost[];
